import { createGlobalStyle, css } from 'styled-components';

const GlobalStyle = createGlobalStyle<{ theme: {[key: string]: any} }>`
  ${({ theme }) => css`
      a:focus {
        outline-color: ${theme.primaryFocusOutlineColor};
      } 
    `}
`;

export default GlobalStyle;
